var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M27,8c-9.4,0-17,7.6-17,17c0,7.1,4.4,13.4,11,15.9V50c0,0.6,0.4,1,1,1h1v2c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1 v-2h1c0.6,0,1-0.4,1-1v-9.1c6.6-2.5,11-8.8,11-15.9C44,15.6,36.4,8,27,8z M30,49c-0.6,0-1,0.4-1,1v2h-4v-2c0-0.6-0.4-1-1-1h-1v-5h8 v5H30z M31.7,39.2c-0.4,0.1-0.7,0.5-0.7,1V42h-8v-1.8c0-0.4-0.3-0.8-0.7-1C16.1,37.2,12,31.5,12,25c0-8.3,6.7-15,15-15 s15,6.7,15,15C42,31.5,37.9,37.2,31.7,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M27,6c0.6,0,1-0.4,1-1V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v4C26,5.6,26.4,6,27,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M51,24h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S51.6,24,51,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M7,24H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S7.6,24,7,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M43.3,7.3l-2.8,2.8c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l2.8-2.8 c0.4-0.4,0.4-1,0-1.4S43.7,6.9,43.3,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M12.1,38.4l-2.8,2.8c-0.4,0.4-0.4,1,0,1.4C9.5,42.9,9.8,43,10,43s0.5-0.1,0.7-0.3l2.8-2.8c0.4-0.4,0.4-1,0-1.4 S12.5,38,12.1,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M41.8,38.4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l2.8,2.8c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L41.8,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M12.1,11.6c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-2.8-2.8c-0.4-0.4-1-0.4-1.4,0 s-0.4,1,0,1.4L12.1,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_learning",
    d: "M27,13c-6.6,0-12,5.4-12,12c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1c0-5.5,4.5-10,10-10c0.6,0,1-0.4,1-1 S27.6,13,27,13z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLearning);
export default __webpack_public_path__ + "static/media/content_learning.70577664c41495435d3fc925aeb418a1.svg";
export { ForwardRef as ReactComponent };